import {format, sub, add} from "date-fns";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-US";
import nl from "date-fns/locale/nl-BE";

const handleLocale = (locale: string) => {
  switch (locale) {
    case "nl":
      return nl;
    case "en":
      return en;
    default:
      return fr;
  }
}

const formatDate = (date: string) => {
  const dateToFormat = date.split(" ").join("T");
  return new Date(dateToFormat);
}

export const handleDate = (date: string | Date, style: string, userLocale?: string) => {
  const locale = userLocale ? handleLocale(userLocale) : fr;
  const dateFormatted = date instanceof Date ? date : formatDate(date);
  return format(dateFormatted, style, { locale });
}

export const fromToDate = (startDate: string | Date, endDate: string | Date, style: string, text: {before: string, between: string, after: string}, userLocale?: string) => {
  const locale = userLocale ? handleLocale(userLocale) : fr;
  const startDateFormatted = startDate instanceof Date ? startDate : formatDate(startDate);
  const endDateFormatted = endDate instanceof Date ? endDate : formatDate(endDate);
  return `${text.before} ${format(startDateFormatted, style, { locale })} ${text.between} ${format(endDateFormatted, style, { locale })} ${text.after}`
}

export const fromToUrl = (startDate: Date, endDate: Date) => {
  const start = format(startDate, "yyyy-MM-dd'T'00:00:00");
  const end = format(endDate, "yyyy-MM-dd'T'23:59:59");
  return `from/${encodeURIComponent(start)}/to/${encodeURIComponent(end)}`;
}

export const todayString = (style: string, userLocale?: string) => {
  const now = new Date();
  return handleDate(now, style, userLocale);
}

export const daysBefore = (nbOfDays: number) => {
  return sub(new Date(), {days: nbOfDays});
}

export const daysAfter = (nbOfDays: number) => {
  return add(new Date(), {days: nbOfDays});
}